import React, { useRef } from 'react';

function useRefTags(tags) {
  const tagObj = {};
  tags.forEach(tag => tagObj[tag] = null);

  const refs = useRef(tagObj);

  const setRefFn = (tag) => {
    return ref => refs.current[tag] = ref;
  }

  return { setRefFn, refs };
}

export default useRefTags;
